var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { create } from "zustand";
import { getSessionList } from "../services/session.service";
import { serverConnection } from "../../modules/multiplayer/server/ServerConnectionService";
export const useSessionListStore = create((set) => ({
    sessions: [],
    setSessions: (sessions) => {
        set({ sessions });
    },
    currentSession: undefined,
    setCurrentSession: (session) => {
        set({ currentSession: session });
    }
}));
export function updateSessionListStore() {
    return __awaiter(this, void 0, void 0, function* () {
        yield new Promise((resolve, reject) => {
            getSessionList()
                .then((sessions) => {
                useSessionListStore.getState().setSessions(sessions);
                resolve();
            })
                .catch((error) => {
                console.error("[ui]", error);
                reject();
            });
        });
    });
}
let interval;
export function startSessionListPolling() {
    if (interval === undefined) {
        interval = window.setInterval(() => __awaiter(this, void 0, void 0, function* () {
            try {
                if (serverConnection.isServerOnline()) {
                    yield updateSessionListStore();
                }
            }
            catch (error) {
                console.error("[ui]", error);
            }
        }), 2000);
    }
}
export function stopSessionListPolling() {
    if (interval !== undefined) {
        clearInterval(interval);
        interval = undefined;
    }
}
